<template>
  <div>
    <h2 style="text-align: center;margin-bottom:30px;">添加礼卡使用记录</h2>
    <el-form ref="form" :model="form" :rules="rules" class="dialog-form">
      <ul class="error-messages" v-if="!isEmptyErrors">
        <li v-for="error in errors">{{ error[0].message }}</li>
      </ul>
      <el-form-item>
        <el-select class="block height-50" v-model="form.merchant_id" placeholder="商家" clearable filterable>
          <el-option v-for="(c, index) in merchantList" :key="index" :label="c.merchant_name"
            :value="c.merchant_id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-input class="block height-50" v-model="form.merchant_order_number" placeholder="商家单号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-row :gutter="12">
          <el-col :span="12">
            <YueDanIpt model="transaction_amount" type="number" :object="form" placeholder="发生金额" :focus="false">
            </YueDanIpt>
          </el-col>
          <el-col :span="12">
            <el-select class="block height-50" v-model="form.currency" placeholder="货币" clearable filterable>
              <el-option v-for="(c, index) in currencies" :key="index" :label="`${c.label}(${c.symbol})`"
                :value="c.value"></el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-button :loading="isSubmitting" style="width: 100%;" type="info" @click="submit('form')">提 交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import api from '../../../services/api.js'
import YueDanIpt from '../../../components/YueDanIpt'
let _ = require('lodash')

export default {
  name: 'AddHistory',
  props: ['currencies', 'giftCardNumber', 'merchantList'],
  computed: {

  },
  components: {
    YueDanIpt: YueDanIpt
  },
  data() {
    return {
      isEmptyErrors: true,
      isSubmitting: false,
      form: {
        order_number: '',
        merchant_order_number: '',
        transaction_amount: '',
        merchant_id:'',
        currency: '',
        symbol: '',
      },
    }
  },
  async mounted() {

  },
  methods: {
    async submit() {
      this.isEmptyErrors = true;
      if (!this.form.merchant_id) {
        this.isEmptyErrors = false;
        this.errors = {
          business_name: [
            { message: '商家必填' }
          ]
        }
        return
      }
      if (!this.form.merchant_order_number) {
        this.isEmptyErrors = false;
        this.errors = {
          business_name: [
            { message: '商家单号必填' }
          ]
        }
        return
      }
      if (!this.form.transaction_amount) {
        this.isEmptyErrors = false;
        this.errors = {
          business_name: [
            { message: '发生金额必填' }
          ]
        }
        return
      }
      if (!this.form.currency) {
        this.isEmptyErrors = false;
        this.errors = {
          business_name: [
            { message: '货币必填' }
          ]
        }
        return
      }
      this.form.symbol = this.currencies.find(item => item.value === this.form.currency).label
      this.form.gift_card_number = this.giftCardNumber;
      let param = this.form;
      this.isSubmitting = true;
      let res = await api.addGiftCardHistory(this, param);
      this.isSubmitting = false;
      if (res.body.status == 'ok') {
        this.$emit('addHistoryPatch2')
      }
    },
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/orders/card/AddHistory.vue